export default {
  methods: {
    goNext(elem) {
      const currentIndex = Array.from(elem.form.elements).indexOf(elem);
      elem.form.elements.item(
        currentIndex < elem.form.elements.length - 1
          ? currentIndex + 1
          : 0,
      ).focus();
    },
  },
};
